/**
 * editing redux selectors
 * 
 * @author    Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


/**
 * select an object by identifier
 * @param state         current state
 * @param objectId      object identifier
 * @returns {Object}    object for given identifier
 * @author Jens Gruschel
 */
export function selectObjectById(state, objectId) {
    if (objectId) return state.objects[objectId] || {};
    else return {};
}

/**
 * select objects for a given list of IDs
 * @param state         current state
 * @param objectIdList  list of object item IDs
 * @returns {Array}     list of objects
 * @author Jens Gruschel
 */
export function selectObjectsForIds(state, objectIdList, omitMissing = false) {

    if (!Array.isArray(objectIdList)) return [];
    if (omitMissing) {
        let result = [];
        objectIdList.forEach(id => {
            const object = state.objects[id];
            if (object) result.push(object);
        });
        return result;
    }
    else {
        return objectIdList.map(id => selectObjectById(state, id));
    }
}

/**
 * select an object by identifier
 * @param state         current state
 * @param objectId      object identifier
 * @returns {Object}    object for given identifier
 * @author Jens Gruschel
 */
export function selectOriginalObjectById(state, objectId) {
    if (objectId) return state.originalObjects[objectId] || {};
    else return {};
}

export function selectModifiedById(state, objectId) {
    if (objectId) return state.modified[objectId];
    else return false;
}

/**
 * select tab indexes of topmost stack item
 * @param state         current state
 * @returns {Object}    tab indexes for given object identifier
 */
export function selectCurrentTabIndexes(state) {
    return selectTopMostObjectStackItem(state).tabIndexes || {};
}

export function selectTopMostObjectStackItem(state) {
    if (state.editStack.length > 0) return state.editStack.slice(-1)[0];
    else return {};
}

export function selectCurrentObjectId(state) {
    return selectTopMostObjectStackItem(state).objectId;
}

export function selectCurrentReferenceFieldPath(state) {
    return selectTopMostObjectStackItem(state).referenceFieldPath;
}

export function selectCurrentElementFieldPath(state) {
    return selectTopMostObjectStackItem(state).elementFieldPath;
}

export function selectCurrentReadOnly(state) {
    return selectTopMostObjectStackItem(state).readOnly;
}

export function selectCurrentFlags(state) {
    return selectTopMostObjectStackItem(state).flags || {};
}
